export const MIN_VACANCY_WARN_PERCENTAGE = 70

export const EXPERIENCE_VACANCY_TYPE_OPACITY = {
  totalAvailable: 0.30,
  reservationsTotal: 1,
  bookingNow: 0.5
}

export const EXPERIENCE_VACANCY_BOX_SHADOW = 'inset 0px 0px 2px 2px'
